<template>
<div class="m-edition-map-chart-node-header">
    <h3 class="node-name">
      <span
        v-if="!isPointsItem"
        class="alfanumeric"
        :style="`background-color: ${itemColor}; border: 1px solid ${itemBorderColor}; color: ${itemColorText};`"
      >
        {{ position }}
      </span>
      <span class="width-inherit">
        {{ element.titulo }}
        <span v-if="!isPointsItem">
          / <span class="font-weight-bold">{{ this.$store.getters.getSelectedMapNode.nombre }}</span>
        </span>
      </span>
    </h3>
    <div class="m-edition-map-chart-node-header-actions">
      <a
        v-if="isNodeItem && (!$store.getters.getSelectedMapNode.tarea || tareaIsEmpty)"
        key="viewState"
        class="a-tooltip-primary a-tooltip-bottom margin-right-medium node-state"
        :data-tooltip-text="visto ? 'Visto' : 'Marcar como visto'"
        href="#"
        @click.prevent="setNodeState"
      >
        <i
          v-if="showLoadingIcon"
          class="far fa-spinner fa-spin node-icon-loading"
        >
        </i>
        <i
          v-else
          :class="visto ? 'fas fa-eye text-color-success' : 'far fa-eye-slash'"
        >
        </i>
      </a>
      <a
        v-if="isNodeItem && $store.getters.getSelectedMapNode.path === 0 &&
          $store.getters.getSelectedMapNode.tarea"
        key="taskState"
        class="a-tooltip-primary a-tooltip-bottom font-size-xsmall"
        :data-tooltip-text="$store.getters.getSelectedMapNode.tareas_alumno.length === 0
          ? 'Tarea Pendiente'
          : `Tarea ${states[$store.getters.getSelectedMapNode.tareas_alumno[$store.getters.getSelectedMapNode.tareas_alumno.length - 1].estado.estado].name}`"
        href="#nodeTask"
      >
        <i
          v-if="$store.getters.getSelectedMapNode.tarea && $store.getters.getSelectedMapNode.tarea.diaEntrega"
          :class="['margin-right-medium ', $store.getters.getSelectedMapNode.tareas_alumno.length === 0
            ? 'fas fa-file-alt text-color-notifications-primary'
            : `${states[$store.getters.getSelectedMapNode.tareas_alumno[$store.getters.getSelectedMapNode.tareas_alumno.length - 1].estado.estado].icon}
              ${states[$store.getters.getSelectedMapNode.tareas_alumno[$store.getters.getSelectedMapNode.tareas_alumno.length - 1].estado.estado].class}`]"
        >
        </i>
      </a>

      <span v-if="!isPointsItem">
        <a
          v-if="previousNode !== -1"
          class="active-action a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mEditionSectionContentInfoNodeActions.tooltips.previous')"
          href="#"
          @click.prevent="goToNode(previousNode)"
        >
          <i class="far fa-chevron-left"></i>
        </a>
        <a
          v-else
          class="inactive-action"
          href="#"
          @click.prevent=""
        >
          <i class="far fa-chevron-left"></i>
        </a>

        <a
          v-if="nextNode !== -1"
          class="active-action a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mEditionSectionContentInfoNodeActions.tooltips.next')"
          href="#"
          @click.prevent="goToNode(nextNode)"
        >
          <i class="far fa-chevron-right"></i>
        </a>
        <a
          v-else
          class="inactive-action"
          href="#"
          @click.prevent=""
        >
          <i class="far fa-chevron-right text-color-black-35"></i>
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChartNodeHeader',

  props: {
    element: {
      type: Object,
      default: () => ({})
    },

    isNodeItem: {
      type: Boolean,
      default: false
    },

    isPointsItem: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      itemBorderColor: '',
      itemColor: '',
      itemColorText: '',
      nodosNavegacion: [],
      position: '',
      showLoadingIcon: false,

      states: [
        {
          icon: 'fas fa-file-exclamation',
          class: 'text-color-info',
          name: 'En Revisión'
        },
        {
          icon: 'fas fa-file-check',
          class: 'text-color-success',
          name: 'Aprobada'
        },
        {
          icon: 'fas fa-file-times',
          class: 'text-color-danger',
          name: 'Rechazada'
        },
        {
          icon: 'fas fa-file-archive',
          class: 'text-color-warning',
          name: 'Eliminada'
        }
      ],

      visto: false
    }
  },

  computed: {
    nextNode () {
      if (this.nodosNavegacion.length) {
        return this.$store.getters.getSelectedMapNode.id
          ? this.nodosNavegacion[this.nodosNavegacion.length - 1].id === this.$store.getters.getSelectedMapNode.id
            ? -1
            : this.nodosNavegacion.findIndex(nodo => nodo.id === this.$store.getters.getSelectedMapNode.id) + 1
          : 1
      } else {
        return -1
      }
    },

    nodos () {
      return this.$store.getters.getMapNodes
    },

    nodosActivosNavegacion () {
      return this.$store.getters.getMapNodesEnrollmentNavigation
    },

    previousNode () {
      if (this.nodosNavegacion.length) {
        return this.$store.getters.getSelectedMapNode.id
          ? this.nodosNavegacion[0].id === this.$store.getters.getSelectedMapNode.id
            ? -1
            : this.nodosNavegacion.findIndex(nodo => nodo.id === this.$store.getters.getSelectedMapNode.id) - 1
          : -1
      } else {
        return -1
      }
    },

    tareaIsEmpty () {
      if (this.$store.getters.getSelectedMapNode.tarea) {
        return (!this.$store.getters.getSelectedMapNode.tarea.archivos ||
          this.$store.getters.getSelectedMapNode.tarea.archivos === undefined) &&
          (!this.$store.getters.getSelectedMapNode.tarea.videos ||
          this.$store.getters.getSelectedMapNode.tarea.videos === undefined) &&
          (this.$store.getters.getSelectedMapNode.tarea.cumplido === 0 ||
          this.$store.getters.getSelectedMapNode.tarea.cumplido === undefined) &&
          (this.$store.getters.getSelectedMapNode.tarea.noCumplido === 0 ||
          this.$store.getters.getSelectedMapNode.tarea.noCumplido === undefined) &&
          (this.$store.getters.getSelectedMapNode.tarea.diaEntrega === 0 ||
          this.$store.getters.getSelectedMapNode.tarea.diaEntrega === undefined)
      } else {
        return true
      }
    }
  },

  watch: {
    '$store.getters.getSelectedMapNode' () {
      this.setItemColor()
      this.setPosition()
      this.getNodoEstadoVisto()
    },

    nodosActivosNavegacion () {
      this.getNodosNavegacion()
      this.getNodoEstadoVisto()
    }
  },

  created () {
    // this.inscripcionId = this.$store.getters.getStudentMapEnrollments.find(enrollment =>
    //   enrollment.id_proyecto === this.$route.params.id && enrollment.activa).id_inscripcion
    this.getNodosNavegacion()
    this.setPosition()
    this.setItemColor()
    this.getNodoEstadoVisto()
  },

  methods: {
    getNodoEstadoVisto () {
      this.visto = this.$store.getters.getSelectedMapNode.visto
        ? this.$store.getters.getSelectedMapNode.visto
        : false
    },

    getNodosNavegacion () {
      this.nodosNavegacion = []
      this.nodosNavegacion = this.nodosActivosNavegacion.length > 0
        ? [...this.nodosActivosNavegacion]
        : []
    },

    goToNode (index) {
      this.$store.commit('setSelectedMapNode', this.nodosNavegacion[index])
    },

    setItemColor () {
      this.itemColor = this.$store.getters.getSelectedMapNode.camino_color
        ? this.$store.getters.getSelectedMapNode.camino_color
        : this.$store.getters.getSelectedMapNode.color
          ? this.$store.getters.getSelectedMapNode.color
          : '#ffffff'

      this.itemColorText = this.$store.getters.getSelectedMapNode.camino_color_nombre
        ? this.$store.getters.getSelectedMapNode.camino_color_nombre
        : this.$store.getters.getSelectedMapNode.color_nombre
          ? this.$store.getters.getSelectedMapNode.color_nombre
          : '#ffffff'

      this.itemBorderColor = this.itemColor !== '#ffffff'
        ? this.itemColor
        : 'var(--color-ui-border-primary)'
    },

    setNodeState () {
      if ((this.previousNode === -1 || this.nodosNavegacion[this.previousNode].visto) &&
        (this.nextNode === -1 || !this.nodosNavegacion[this.nextNode].visto)) {
        this.updateInscripcionNodoEstado()
      }
    },

    setPosition () {
      this.position = this.$store.getters.getSelectedMapNode.camino_alfanumerico
        ? `${this.$store.getters.getSelectedMapNode.camino_alfanumerico}${this.$store.getters.getSelectedMapNode.alfanumerico}`
        : this.$store.getters.getSelectedMapNode.alfanumerico
    },

    updateInscripcionNodoEstado () {
      if (!this.showLoadingIcon) {
        this.visto = +!this.visto
        this.showLoadingIcon = true
        this.$services.update('inscripcion', 'updateInscripcionNodoEstado', { visto: this.visto }
          , [this.$store.getters.getAcademyData.id, this.element.id_inscripcion, this.$store.getters.getSelectedMapNode.id])
          .then(response => {
            this.$modal.updateData('readInscripcionNodos')
            this.showLoadingIcon = false
          })
          .catch(error => {
            console.log(error)
            this.showLoadingIcon = false
            this.$alerts.pushAlert('mEditionSectionContentInfoNodeActions', 'updateInscripcionNodoEstado', 'error', 'a-alert-danger')
          })
      }
    }
  }
}
</script>
